import { storageName } from '../utils/storage';
import Dexie from 'dexie';

// Deliberately separate from NewsDatabase: refreshing the feed must never
// remove private local recordings. Blob URLs are only made while rendering.
const database = new Dexie(storageName('WiwRecordingDrafts'));
database.version(1).stores({ drafts: 'key, userId, updatedAt' });
export const mediaDraftKey = (userId, storyId, draftId) => `${userId}:${storyId}:${draftId}`;
export const readMediaDraft = key => database.drafts.get(key);
export const writeMediaDraft = draft => database.drafts.put({ ...draft, updatedAt: Date.now() });
export const deleteMediaDraft = key => database.drafts.delete(key);
